import * as style from './style.css';
import { Responsive } from '@cian/ui-kit';
import { ReactNode } from 'react';

interface IBuildingProps {
  header: ReactNode;
  address: ReactNode;
  description: ReactNode;
  layoutLinks: ReactNode;
}

export const BuildingWrapper = ({ header, address, description, layoutLinks }: IBuildingProps) => {
  return (
    <div className={style['container']}>
      {header}
      {address}

      <Responsive desktop>{description}</Responsive>

      {layoutLinks}
    </div>
  );
};
